import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import { getDefaults, getInitial, getIoConfig, getPropsConfig } from './_base-chart.element';
import { ColumnChartDefinitionMapper } from './ai/chart.definition-mapper';
import { ColumnChartElementHandler } from './ai/column-chart.element-handler';
import { ChartComponent } from './chart.component';
import { CHART_DIMENSIONS } from './chart.models';
import { ChartPropsBuilder } from './chart.props-builder';
import { ChartPropsExtractor } from './chart.props-extractor';
import { chartV2Migration } from './migrations/002-all-chart-types.migration';
import { chartV3Migration } from './migrations/003-chart.migration';

export function getColumnChartDefinition(): CanvasElementDefinition<'chartColumn'> {
  return {
    type: 'chartColumn',
    componentType: ChartComponent<'chartColumn'>,
    isListed: true,
    name: 'Column Chart',
    width: { mode: 'value', value: CHART_DIMENSIONS.width, fixed: true },
    height: { mode: 'value', value: CHART_DIMENSIONS.height, fixed: true },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig('chartColumn'),
    propsBuilder: ChartPropsBuilder,
    propsExtractor: ChartPropsExtractor,
    defaults: getDefaults('Column Chart'),
    initial: getInitial(),
    groups: ['charts'],
    styleIncludePaths: [
      'style',
      'content.font.fontFamily',
      'content.font.style',
      'content.font.fontSize',
      'content.title.iconPosition',
    ],
    features: {
      ai: {
        showAiPromptAutomatically: true,
        description: true,
      },
      visualStyle: 'block',
    },
    ai: {
      name: 'chartColumn',
      handler: () => ColumnChartElementHandler,
      definitionMapper: () => ColumnChartDefinitionMapper,
    },

    version: 3,
    migrations: {
      2: chartV2Migration,
      3: chartV3Migration,
    },
  };
}
